// src/components/PromoCodeManager.js
import React from 'react';

export default function PromoCodeManager({ codes, onDelete }) {
  return (
    <div className="promocode-manager">
      <h6>Существующие промокоды</h6>
      {codes.length === 0 ? <p className="no-items">Нет кодов</p> : (
        <ul className="promocode-list">
          {codes.map(pc => (
            <li key={pc.id} className="promocode-item">
              <div className="promocode-info">
                <span className="promocode-code">{pc.code}</span>
                <span className="promocode-details">{pc.points} очков</span>
                <span className="promocode-details">
                  {pc.usesLeft !== null ? `Исп: ${pc._count.activations} / ${pc.usesLeft}` : `Исп: ${pc._count.activations}`}
                </span>
              </div>
              <button className="delete-button-small" onClick={() => onDelete(pc.id)}>&times;</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}